import { Text, View, StyleSheet, Image, Dimensions, TouchableOpacity, Animated, ActivityIndicator } from 'react-native'
import theme from '../../../theme'
import { colorText } from '../../../themeConstants'

const { width, height } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
        width: '100%',
    },
})

export default styles
